import stats from '../util/stats';

export default class CookieConsent {
  constructor($element) {
    this.$element = $element;

    this.yesMessage = this.$element.getAttribute('data-yes');
    this.noMessage = this.$element.getAttribute('data-no');

    this.setConsent(!stats.getCookie('piwik_ignore'));

    this.$element.addEventListener('click' , (e) => {
      e.preventDefault();
      this.onClick();
    })
  }

  setConsent(consent) {
    this.hasConsent = consent;

    if (this.hasConsent) {
      stats.setCookie('piwik_ignore','',-1);
    } else {
      stats.setCookie('piwik_ignore','1',365);
    }

    this.$element.innerHTML = (this.hasConsent) ? this.yesMessage : this.noMessage;

  }

  onClick() {
    this.setConsent(!this.hasConsent);
  }

}



// WEBPACK FOOTER //
// ./scripts/dom/CookieConsent.js